module.exports = __webpack_public_path__ + "img/youtube2.1fb74cff.svg";